<usimweb-status-bar
  *ngIf="progress$ | async"
  style="top: 0px !important; height: 20px"
  [mode]="'indeterminate'"></usimweb-status-bar>

<div class="dashboard">
  <div class="row mt-4">
    <div style="display: inline-block; width: 98%">
      <usimweb-filter-menu (filter)="filter($any($event))"></usimweb-filter-menu>
    </div>
  </div>
  <div class="row mt-4 gx-6">
    <div class="col-sm-6 col-lg-6 col-xl-3 mb-3">
      <usimweb-projectcard
        [newProject]="true"
        [newItemLink]="'newProject'"
        [newCardTitle]="'New project'"  data-cy="newProject"></usimweb-projectcard>
    </div>

    <div class="col" *ngIf="(projects$ | async)?.length == 0">
      <div class="p-4 project-info-div">
        <h1>My Projects</h1>
        <p>
          You want to get started? Or do you want to navigate to your latest analysis? <br />
          On this page you can administrate all of your projects.
          <br />
          <br />
          To start with a new project, please click on the "+" button.
        </p>
      </div>
    </div>

    <div class="col-sm-6 col-lg-6 col-xl-3 mb-3" *ngFor="let project of (projects$ | async)!">
      <usimweb-projectcard
        [user]="user"
        [cardItem]="project"
        [link]="projectLink"
        [emptyProjectLink]="emptyProjectLink"
        [isProjectCard]="true"
        [showBar]="true"
        (dialogEvent)="openDialog($event)"
        (favouriteChangedEvent)="favouriteChanged($event)"></usimweb-projectcard>
    </div>
  </div>
</div>
